import "./DigitalProgramPage.scss";
import React from "react";
import Header from "../../components/ui/StickyHeader";
import Button from "../../components/ui/Button";
import TextBlock from "../../components/ui/TextBlock";
import mobileHeaderImage from "../../assets/Mobile_header.png";

const DigitalProgram = () => {
	return (
		<>
			<Header
				logoBeforeScroll={require("../../assets/bmw_logo-allWhite.png")}
				showEnrollButton={false}
			/>
			<div style={{ backgroundColor: "black" }}>
				{/* ------------ hero ------------ */}
				<div className="hero-container-wrapper">
					<div
						className="hero-container-digital-program"
						style={{
							"--mobile-header-bg": `url(${mobileHeaderImage})`,
						}}>
						<TextBlock
							hat=""
							title={
								<>
									REAL STORIES. <br />
									LOCAL DEALERSHIPS. ZERO Fees.
								</>
							}
							paragraph={
								<>
									Video and photo production packages designed
									to bring your dealership to life.
									<br />
									Built for Tier-3 performance across every
									screen and platform.
								</>
							}
							type="h1"
							color="white"
							align="center"
						/>
						<div className="button-container">
							<div className="button-container-inner">
								<Button
									link="/digital-program/constellation"
									styleName="blue"
									size="large">
									Enroll in Video Package
								</Button>
								<div className="powered-by-container">
									<TextBlock
										paragraph="Powered by"
										type="p-block"
										align="center"
										classNames="constellation-section-paragraph"
									/>
									<img
										src={require("../../assets/footerImgs/constellation.png")}
										alt="Constellation"
									/>
								</div>
							</div>
							<div className="button-container-inner">
								<Button
									link="http://aimgblitz.com/"
									styleName="blue"
									size="large">
									Enroll in Photography Package
								</Button>
								<div className="powered-by-container">
									<TextBlock
										paragraph="Powered by"
										type="p-block"
										align="center"
										classNames="constellation-section-paragraph"
									/>
									<img
										src={require("../../assets/digitalProgram/ai-media.png")}
										alt="Ai Media"
										className="ai-media-logo"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default DigitalProgram;
